// @ts-check
// Peças comuns das telas de modelo de dados: cabeçalho com trilha, permissão de edição e erros do motor.
import { html } from 'htm/preact';
import { Link } from '../../../app/router.js';
import { ApiError, getErrorMessage } from '../../../data/api-client.js';
import { allObjectsState, hasCurrentPermissionFlag } from '../../../data/metadata-store.js';
import { enqueueSnackbar } from '../../../ui/snackbar.js';
import { t, translateMetadataLabel } from '../../../i18n/index.js';

/** Só papéis com a flag DATA_MODEL mudam objetos e campos (a API responde 403 aos demais). */
export const canEditDataModel = () => hasCurrentPermissionFlag('DATA_MODEL');

/** @param {string} namePlural */
export const findObjectByNamePlural = (namePlural) => allObjectsState.value.find((object) => object.namePlural === namePlural);

/**
 * Trilha "Modelo de dados / Objeto / Campo"; o último item não é link.
 * @param {{ items: Array<{ label: string, href?: string }> }} props
 */
export function DataModelBreadcrumb({ items }) {
  return html`<nav class="record-breadcrumb" aria-label=${t('dataModel.common.breadcrumb')}>
    ${items.map((item, index) => html`${index > 0 ? html`<span class="record-breadcrumb-separator">/</span>` : null}
      ${item.href
        ? html`<${Link} href=${item.href} className="record-breadcrumb-prefix">${item.label}<//>`
        : html`<span class="record-breadcrumb-current">${item.label}</span>`}`)}
  </nav>`;
}

/** @param {import('../../../lib/field-metadata.js').ObjectMetadata} object */
export const objectBreadcrumbItem = (object) => ({ label: translateMetadataLabel(object.labelPlural), href: `/settings/objects/${object.namePlural}` });

/** Item raiz com o rótulo traduzido na hora (o catálogo pode carregar depois do módulo). */
export const rootBreadcrumbItem = () => ({ label: t('dataModel.title'), href: '/settings/objects' });

/**
 * Erro do motor: título amigável e, para recusas de validação, a explicação devolvida pela API.
 * @param {unknown} error
 */
export function showDataModelError(error) {
  const detailedMessage = error instanceof ApiError && error.code === 'METADATA_VALIDATION_FAILED' ? error.messages[0] : undefined;
  enqueueSnackbar({ message: getErrorMessage(error), detailedMessage, variant: 'error' });
}

/**
 * Seção "zona de perigo" com o mesmo visual das outras seções.
 * @param {{ title: string, description: string, children: any }} props
 */
export function DangerZone({ title, description, children }) {
  return html`<section class="settings-section data-model-danger-zone">
    <div class="settings-section-header">
      <h2 class="settings-section-title">${title}</h2>
      <p class="settings-section-description">${description}</p>
    </div>
    <div class="data-model-danger-actions">${children}</div>
  </section>`;
}
